import React from 'react';
import { CalendarIcon, VideoIcon } from '../../../components/common/IconsComponent';

const avatars = [1, 2, 3, 4];

const HeroStats = () => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
    <div className="flex -space-x-3">
      {avatars.map((i) => (
        <img
          key={i}
          src={`https://i.pravatar.cc/100?img=${i}`}
          alt={`Student ${i}`}
          className="h-10 w-10 rounded-full border-2 border-white object-cover"
          loading="lazy"
        />
      ))}
    </div>
    <div className="flex flex-wrap gap-3 text-sm text-white">
      <div className="flex items-center gap-1.5">
        <CalendarIcon className="h-4 w-4" aria-hidden="true" />
        <span>Flexible Schedule</span>
      </div>
      <div className="flex items-center gap-1.5">
        <VideoIcon className="h-4 w-4" aria-hidden="true" />
        <span>Live Classes</span>
      </div>
    </div>
  </div>
);

export default HeroStats;